
import { Container, Row } from "reactstrap";
import styled from "styled-components";

export const SponsorsContainer = styled(Container)`
  margin-top: 6%;
  margin-bottom: 6%;
`;

export const SponsorsRow = styled(Row)``;

export const SponsorCard = styled.div`
  background: white;
  border-radius: 15px;
  padding: 2rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  height: 100%;
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
  }
`;

export const SponsorLogo = styled.div`
  width: 100%;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  
  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`;

export const LevelTitle = styled.h3`
  color: ${props => props.color || '#333'};
  font-weight: bold;
  font-size: 1.8rem;
  margin-bottom: 1rem;
  text-align: center;
`;

export const BenefitsList = styled.ul`
  list-style: none;
  padding: 0;
  
  li {
    padding: 0.5rem 0;
    padding-left: 2rem;
    position: relative;
    color: #555;
    
    &:before {
      content: "✓";
      position: absolute;
      left: 0;
      color: #28a745;
      font-weight: bold;
      font-size: 1.2rem;
    }
  }
`;

export const SponsorGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 1.5rem;
  padding: 2rem 0;
`;

export const PricingTable = styled.table`
  width: 100%;
  background: white;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  
  small {
    font-size: 0.8rem;
    font-weight: normal;
    color: #666;
  }
`;

export const TableHeader = styled.tr`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  
  th {
    padding: 1.5rem 1rem;
    text-align: center;
    font-weight: 600;
    border-right: 1px solid rgba(255, 255, 255, 0.1);
    
    &:last-child {
      border-right: none;
    }
    
    &:first-child {
      text-align: left;
    }
  }
`;

export const TableRow = styled.tr`
  &:nth-child(even) {
    background: #f8f9fa;
  }
  
  &:hover {
    background: #e9ecef;
  }
`;

export const TableCell = styled.td`
  padding: 1rem;
  text-align: center;
  border-right: 1px solid #dee2e6;
  color: #333;
  
  &:last-child {
    border-right: none;
  }
  
  &:first-child {
    text-align: left;
    font-weight: 500;
  }
`;

export const CheckIcon = styled.span`
  color: #28a745;
  font-size: 1.2rem;
  font-weight: bold;
`;

export const SponsorshipLevel = styled.div`
  background: ${props => props.bgColor || '#f8f9fa'};
  border-radius: 15px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  }
  
  h3 {
    color: white;
    margin-bottom: 1rem;
  }
  
  .price {
    font-size: 2rem;
    font-weight: bold;
    color: white;
    margin-bottom: 1.5rem;
  }
`;

export const StatCard = styled.div`
  padding: 1.5rem;
  background: white;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
  }
`;

export const LogoPlaceholder = styled.div`
  background: #f0f0f0;
  padding: 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100px;
  transition: all 0.3s ease;
  cursor: pointer;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }
  
  span {
    color: #999;
    font-size: 0.9rem;
    text-align: center;
  }
`;